"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Widget = void 0;
var _icons = require("@ori-ui/icons");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const Widget = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    novageSkincareConfiguration
  } = (0, _contexts.useNovageSkincareAdvisor)();
  const {
    open,
    onClose
  } = (0, _presentationHooks.useDisclose)({
    defaultOpen: true
  });
  if (!novageSkincareConfiguration?.recommendationPageEnabled || !open || !(0, _utils.shouldOpenForCurrentUrlPathname)()) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants2.WIDGET),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Link, {
      href: _constants.OPEN_HREF_ATTRIBUTE,
      underline: "none",
      children: translations.scanYourSkin
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CloseButton, {
      "aria-label": translations.closeScanYourSkin,
      onClick: onClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
    })]
  });
};
exports.Widget = Widget;